import type { ReactElement } from 'react';
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';

export interface CloverInvalidationConfirmationDialogProps {
    readonly open: boolean;
    readonly onOpenChange: (open: boolean) => void;
    readonly onConfirm: () => void;
}

/** In-page warning before the Organization-wide Clover grant is invalidated (BUG-252). */
export function CloverInvalidationConfirmationDialog({
    open,
    onOpenChange,
    onConfirm,
}: CloverInvalidationConfirmationDialogProps): ReactElement {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent data-clover-invalidation-confirmation="true">
                <DialogHeader>
                    <DialogTitle>Invalidate Clover authorization</DialogTitle>
                    <DialogDescription>
                        Invalidate Clover authorization for this organization? All Clover payments
                        will stop until authorization succeeds again.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button
                        type="button"
                        variant="outline"
                        data-clover-invalidation-cancel="true"
                        onClick={() => onOpenChange(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        variant="destructive"
                        data-clover-invalidation-confirm="true"
                        onClick={() => {
                            onOpenChange(false);
                            onConfirm();
                        }}
                    >
                        Invalidate
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
